export default "__VITE_ASSET__c19295f2__"